const mediaItems = [
  {
    title: '《暗夜追踪》独家上线',
    desc: '2026年度动作悬疑巨制，高能反转全程无尿点',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20thriller%20scene%20with%20dramatic%20lighting%20and%20mysterious%20silhouette%20film%20noir%20aesthetic%20warm%20coral%20accent%20lighting%20against%20deep%20shadows%20professional%20cinematography%20style%20high%20detail%20atmospheric%20composition&width=400&height=250&seq=media-01-69&orientation=landscape',
    dur: '128分钟',
    tag: '动作悬疑',
  },
  {
    title: '《欢乐喜剧人》巅峰对决',
    desc: '笑料不断，本期嘉宾阵容空前强大',
    img: 'https://readdy.ai/api/search-image?query=Bright%20energetic%20comedy%20stage%20with%20colorful%20stage%20design%20and%20spotlights%20warm%20golden%20lighting%20live%20performance%20atmosphere%20entertainment%20venue%20feel%20professional%20photography%20style%20high%20detail&width=400&height=250&seq=media-02-69&orientation=landscape',
    dur: '95分钟',
    tag: '综艺',
  },
  {
    title: '《深海秘境》4K纪录片',
    desc: '潜入万米深海，探索未知的奇幻世界',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20ocean%20scene%20with%20bioluminescent%20creatures%20and%20deep%20blue%20gradients%20mysterious%20marine%20atmosphere%20with%20warm%20coral%20light%20rays%20penetrating%20water%20cinematic%20documentary%20style%20high%20detail&width=400&height=250&seq=media-03-69&orientation=landscape',
    dur: '90分钟',
    tag: '自然纪录',
  },
  {
    title: '《星辰变》第二季重磅回归',
    desc: '热血修仙路，经典IP动画全新篇章',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20animation%20art%20with%20flowing%20energy%20effects%20and%20celestial%20background%20warm%20golden%20and%20coral%20glowing%20particles%20epic%20fantasy%20atmosphere%20professional%20illustration%20style%20dynamic%20composition%20high%20detail&width=400&height=250&seq=media-04-69&orientation=landscape',
    dur: '24集',
    tag: '动画',
  },
  {
    title: '《都市夜话》情感夜话特辑',
    desc: '倾听城市故事，感受人间烟火温度',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20nighttime%20cityscape%20with%20warm%20window%20lights%20and%20soft%20urban%20atmosphere%20intimate%20mood%20with%20coral%20and%20golden%20lighting%20reflections%20cinematic%20photography%20style%20emotional%20composition%20high%20detail&width=400&height=250&seq=media-05-69&orientation=landscape',
    dur: '55分钟',
    tag: '情感',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            精选优质视频内容，总有一部适合你
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {mediaItems.map((item, i) => (
              <article
                key={i}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                      <i className="ri-play-fill text-xl"></i>
                    </span>
                  </div>
                  <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded text-xs bg-black/70 text-white whitespace-nowrap">
                    {item.dur}
                  </span>
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2">
                    <span className="px-1.5 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500 line-clamp-1">{item.desc}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}